import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedAdditionalService = () => {
  return {
    active: false,
    freeForPermi: false,
    additionalServiceTypeId: null,
    basePrice: [],
    pricingPeriods: [],
  };
};

export default {
  state: () => ({
    selectedAdditionalService: getDefaultSelectedAdditionalService(),
  }),

  mutations: {
    setSelectedAdditionalService(state, additionalService) {
      Vue.set(state, "selectedAdditionalService", additionalService);
    },
    setDefaultSelectedAdditionalService(state) {
      Vue.set(state, "selectedAdditionalService", getDefaultSelectedAdditionalService());
    },
  },
  actions: {
    //TODO: load, update, create
    createAdditionalService: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/additional-services/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadAdditionalServices: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedAdditionalServices: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/entity/published").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadAdditionalService: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadAdditionalServiceHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/additional-services/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedAdditionalServiceHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteAdditionalService: (context, additionalService) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-services/entity/" + additionalService.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          additionalService.intents = intents;
          additionalService.intentId = response.data.id;
          return additionalService;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftAdditionalService: (context, additionalService) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/additional-services/draft/" + additionalService.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishAdditionalService: (context, additionalService) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/publish/" + additionalService.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectAdditionalService: (context, additionalService) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/reject/" + additionalService.intentId).then((response) => {
        if (additionalService.intents[0].type === "DELETE_ADDITIONAL_SERVICE") {
          additionalService.intents = null;
          additionalService.intentId = 0;
        } else if (additionalService.intents[0].type === "CREATE_ADDITIONAL_SERVICE") {
          additionalService.intents[0].status = "DRAFT";
        } else if (additionalService.intents[0].type === "UPDATE_ADDITIONAL_SERVICE") {
          additionalService.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalAdditionalService: (context, additionalService) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/sendToApproval/" + additionalService.intentId).then((response) => {
        if (additionalService.intents[0].type === "CREATE_ADDITIONAL_SERVICE") {
          additionalService.intents[0].status = "WAITING_APPROVAL";
        } else if (additionalService.intents[0].type === "UPDATE_ADDITIONAL_SERVICE") {
          additionalService.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallAdditionalService: (context, additionalService) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/recall/" + additionalService.intentId).then((response) => {
        helper.recallOrRejectEntity(additionalService, "ADDITIONAL_SERVICE");
        return response.data;
      });
    },

    cancelAdditionalService: (context, additionalService) => {
      return axios.get(context.getters.getMcServiceUrl + "/additional-services/cancel/" + additionalService.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedAdditionalService: (state) => {
      return state.selectedAdditionalService;
    },
  },
};
